import { DAY_SET, DAY_RESET } from '../types/General/dayMovement'  

const initialState = {
    date: '',
}

const dayMovementReducer = (state = initialState, action) => {
    switch (action.type) {
        case DAY_SET:
            return {
                ...state,
                date: action.payload.date
            }
            break;
        case DAY_RESET:
            return {
                ...state,
                date: ''
            }
            break;
        default: return state
    }
}

export default dayMovementReducer